import Turnstile, { useTurnstile } from "react-turnstile";
import Modal from "@/components/common/Modal";
import { useCallback } from "react";
import { enhancedApi } from "@/shared/services/enhancedApi";

interface RecaptchaModalProps {
  isOpen: boolean;
  onClose: (isValidated?: boolean) => void;
}

const RecaptchaModal: React.FC<RecaptchaModalProps> = ({ isOpen, onClose }) => {
  const turnstile = useTurnstile();
  const validateRecaptchaToken = useCallback(
    async (token: string) => {
      let canProceedToPayment = false;
      try {
        // Make API call using enhancedApi for rate limiting and retry logic
        const response = await enhancedApi.post<{
          success: boolean;
          code: number;
          message: string;
        }>(
          "/api/recaptcha/validate",
          {
            captchaToken: token,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        canProceedToPayment = response.code === 200;
      } catch (err) {
        console.error("validateRecaptchaToken: Conversion failed:", err);
        canProceedToPayment = false;
      } finally {
        onClose(canProceedToPayment);
      }
    },
    [onClose]
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        turnstile.reset();
        onClose(false);
      }}
      title="Verify You're Human"
      className="recaptcha-modal"
    >
      <div className="p-4 content-wrapper">
        <p>Click the checkbox below to verify</p>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <Turnstile
            sitekey={import.meta.env.VITE_TURNSTILE_SITE_KEY  || ''}
            size="normal"
            onVerify={validateRecaptchaToken}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RecaptchaModal;
